// src/components/audition-booking-wizard/WizardHeader.jsx
import React from 'react';
import { WIZARD_STEPS } from './utils/bookingHelpers'; // Use dynamic steps

const WizardHeader = ({ currentStep, selectedMode }) => {
    const steps = WIZARD_STEPS(selectedMode);
    return (
        <div className="red-header-bar">
            <span>{steps[currentStep - 1]?.toUpperCase() || 'PROCESS'}</span>
            <span>STEP {currentStep} OF {steps.length}</span>
        </div>
    );
};

export default WizardHeader;